import React from 'react';
import text from '../../text';
import routes from '../../routes/constants';
var FooterBottom = function() {
    return /*#__PURE__*/ React.createElement("div", {
        id: "FooterBottom"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "FooterBottom-Start"
    }, text('copyright')), /*#__PURE__*/ React.createElement("div", {
        className: "FooterBottom-End"
    }, /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiWebsiteUrl.privacy,
        target: "_blank",
        rel: "noreferrer"
    }, text('privacyPolicy')), /*#__PURE__*/ React.createElement("span", null, "|"), /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiWebsiteUrl.custTermsCond,
        target: "_blank",
        rel: "noreferrer"
    }, text('customerTermsConditions')), /*#__PURE__*/ React.createElement("span", null, "|"), /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiWebsiteUrl.supplierTermsCond,
        target: "_blank",
        rel: "noreferrer"
    }, text('supplierTermsConditions'))));
};
export default FooterBottom;
